import React, { useState } from 'react';
import { LinkedinIcon, MailIcon, GlobeIcon, CheckIcon, PlusIcon, XIcon, ChevronRightIcon } from 'lucide-react';
export const DataSources: React.FC = () => {
  const [activeTab, setActiveTab] = useState('linkedin');
  const [showAddSource, setShowAddSource] = useState(false);
  const [showSourceDetails, setShowSourceDetails] = useState<number | null>(null);
  const [newSource, setNewSource] = useState({
    name: '',
    type: 'linkedin',
    url: ''
  });
  const [sources, setSources] = useState([{
    id: 1,
    name: 'Company LinkedIn Page',
    type: 'linkedin',
    status: 'active',
    lastSync: '2 hours ago',
    stats: {
      posts: 24,
      engagements: 137
    }
  }, {
    id: 2,
    name: 'Personal LinkedIn Profile',
    type: 'linkedin',
    status: 'active',
    lastSync: '1 day ago',
    stats: {
      posts: 18,
      engagements: 93
    }
  }, {
    id: 3,
    name: 'Marketing Email Campaign',
    type: 'email',
    status: 'inactive',
    lastSync: '1 week ago',
    stats: {
      sent: 250,
      opened: 112,
      clicked: 43
    }
  }, {
    id: 4,
    name: 'Company Website',
    type: 'web',
    status: 'active',
    lastSync: '3 days ago',
    stats: {
      visits: 1250,
      conversions: 32
    }
  }]);
  const handleAddSource = () => {
    if (!newSource.name || !newSource.url) return;
    setSources([...sources, {
      id: sources.length + 1,
      name: newSource.name,
      type: newSource.type as any,
      status: 'active',
      lastSync: 'Just now',
      stats: newSource.type === 'linkedin' ? {
        posts: 0,
        engagements: 0
      } : newSource.type === 'email' ? {
        sent: 0,
        opened: 0,
        clicked: 0
      } : {
        visits: 0,
        conversions: 0
      }
    }]);
    setNewSource({
      name: '',
      type: 'linkedin',
      url: ''
    });
    setShowAddSource(false);
  };
  const getSourceIcon = (type: string) => {
    switch (type) {
      case 'linkedin':
        return <LinkedinIcon size={18} className="text-blue-600" data-id="element-305" />;
      case 'email':
        return <MailIcon size={18} className="text-green-600" data-id="element-306" />;
      case 'web':
        return <GlobeIcon size={18} className="text-purple-600" data-id="element-307" />;
      default:
        return null;
    }
  };
  const toggleSourceDetails = (id: number) => {
    setShowSourceDetails(showSourceDetails === id ? null : id);
  };
  const filteredSources = sources.filter(source => activeTab === 'all' || source.type === activeTab);
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6" data-id="element-308">
      <div className="flex justify-between items-center mb-4" data-id="element-309">
        <h2 className="text-lg font-medium text-gray-900" data-id="element-310">Data Sources</h2>
        <button onClick={() => setShowAddSource(!showAddSource)} className="inline-flex items-center px-3 py-1.5 text-sm font-medium rounded-md text-white bg-[#f9b30f] hover:bg-[#e0a40e]" data-id="element-311">
          <PlusIcon size={16} className="mr-1" data-id="element-312" />
          Add Source
        </button>
      </div>
      <div className="mb-4 overflow-x-auto" data-id="element-313">
        <div className="border-b border-gray-200 min-w-max" data-id="element-314">
          <nav className="-mb-px flex space-x-4 sm:space-x-8" data-id="element-315">
            <button onClick={() => setActiveTab('linkedin')} className={`whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'linkedin' ? 'border-[#f9b30f] text-[#f9b30f]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-316">
              LinkedIn
            </button>
            <button onClick={() => setActiveTab('email')} className={`whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'email' ? 'border-[#f9b30f] text-[#f9b30f]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-317">
              Email
            </button>
            <button onClick={() => setActiveTab('web')} className={`whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'web' ? 'border-[#f9b30f] text-[#f9b30f]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-318">
              Website
            </button>
            <button onClick={() => setActiveTab('all')} className={`whitespace-nowrap pb-4 px-1 border-b-2 font-medium text-sm ${activeTab === 'all' ? 'border-[#f9b30f] text-[#f9b30f]' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-319">
              All Sources
            </button>
          </nav>
        </div>
      </div>
      {showAddSource && <div className="mb-6 p-4 bg-gray-50 rounded-lg border border-gray-200" data-id="element-320">
          <div className="flex justify-between items-center mb-3" data-id="element-321">
            <h3 className="text-sm font-medium text-gray-700" data-id="element-322">
              Add New Data Source
            </h3>
            <button onClick={() => setShowAddSource(false)} className="text-gray-400 hover:text-gray-500" data-id="element-323">
              <XIcon size={18} data-id="element-324" />
            </button>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4" data-id="element-325">
            <div data-id="element-326">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-327">
                Source Name
              </label>
              <input type="text" value={newSource.name} onChange={e => setNewSource({
            ...newSource,
            name: e.target.value
          })} placeholder="E.g. Marketing LinkedIn Page" className="block w-full pl-3 pr-3 py-2 text-sm border-gray-300 focus:outline-none focus:ring-[#f9b30f] focus:border-[#f9b30f] rounded-md" data-id="element-328" />
            </div>
            <div data-id="element-329">
              <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-330">
                Source Type
              </label>
              <select value={newSource.type} onChange={e => setNewSource({
            ...newSource,
            type: e.target.value
          })} className="block w-full pl-3 pr-10 py-2 text-sm border-gray-300 focus:outline-none focus:ring-[#f9b30f] focus:border-[#f9b30f] rounded-md" data-id="element-331">
                <option value="linkedin" data-id="element-332">LinkedIn</option>
                <option value="email" data-id="element-333">Email Campaign</option>
                <option value="web" data-id="element-334">Website</option>
              </select>
            </div>
          </div>
          <div className="mb-4" data-id="element-335">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-336">
              URL or Identifier
            </label>
            <input type="text" value={newSource.url} onChange={e => setNewSource({
          ...newSource,
          url: e.target.value
        })} placeholder={newSource.type === 'linkedin' ? 'LinkedIn profile/company URL' : newSource.type === 'email' ? 'Campaign identifier or name' : 'Website URL'} className="block w-full pl-3 pr-3 py-2 text-sm border-gray-300 focus:outline-none focus:ring-[#f9b30f] focus:border-[#f9b30f] rounded-md" data-id="element-337" />
          </div>
          <div className="flex justify-end" data-id="element-338">
            <button onClick={handleAddSource} disabled={!newSource.name || !newSource.url} className="px-4 py-2 bg-[#f9b30f] hover:bg-[#e0a40e] rounded-md text-sm font-medium text-white disabled:opacity-50" data-id="element-339">
              Add Source
            </button>
          </div>
        </div>}
      {/* Desktop table view */}
      <div className="hidden md:block overflow-x-auto" data-id="element-340">
        <table className="min-w-full divide-y divide-gray-200" data-id="element-341">
          <thead className="bg-gray-50" data-id="element-342">
            <tr data-id="element-343">
              <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-344">
                Source
              </th>
              <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-345">
                Status
              </th>
              <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-346">
                Last Sync
              </th>
              <th scope="col" className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-347">
                Stats
              </th>
              <th scope="col" className="relative px-4 py-3" data-id="element-348">
                <span className="sr-only" data-id="element-349">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200" data-id="element-350">
            {filteredSources.map(source => <tr key={source.id} data-id="element-351">
                <td className="px-4 py-4 whitespace-nowrap" data-id="element-352">
                  <div className="flex items-center" data-id="element-353">
                    <div className="flex-shrink-0 h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-354">
                      {getSourceIcon(source.type)}
                    </div>
                    <div className="ml-3" data-id="element-355">
                      <div className="text-sm font-medium text-gray-900" data-id="element-356">
                        {source.name}
                      </div>
                    </div>
                  </div>
                </td>
                <td className="px-4 py-4 whitespace-nowrap" data-id="element-357">
                  <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${source.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-358">
                    {source.status === 'active' ? <>
                        <CheckIcon size={12} className="mr-1" data-id="element-359" />
                        Active
                      </> : 'Inactive'}
                  </span>
                </td>
                <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-360">
                  {source.lastSync}
                </td>
                <td className="px-4 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-361">
                  {source.type === 'linkedin' && <>
                      {source.stats.posts} posts, {source.stats.engagements}{' '}
                      engagements
                    </>}
                  {source.type === 'email' && <>
                      {source.stats.sent} sent, {source.stats.opened} opened,{' '}
                      {source.stats.clicked} clicked
                    </>}
                  {source.type === 'web' && <>
                      {source.stats.visits} visits, {source.stats.conversions}{' '}
                      conversions
                    </>}
                </td>
                <td className="px-4 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-362">
                  <button className="text-[#f9b30f] hover:text-[#e0a40e]" data-id="element-363">
                    Sync
                  </button>
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
      {/* Mobile card view */}
      <div className="md:hidden space-y-4" data-id="element-364">
        {filteredSources.map(source => <div key={source.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-365">
            <div className="p-4 flex justify-between items-center cursor-pointer" onClick={() => toggleSourceDetails(source.id)} data-id="element-366">
              <div className="flex items-center" data-id="element-367">
                <div className="flex-shrink-0 h-8 w-8 rounded-full bg-gray-100 flex items-center justify-center" data-id="element-368">
                  {getSourceIcon(source.type)}
                </div>
                <div className="ml-3" data-id="element-369">
                  <div className="text-sm font-medium text-gray-900" data-id="element-370">
                    {source.name}
                  </div>
                  <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${source.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-800'}`} data-id="element-371">
                    {source.status === 'active' ? 'Active' : 'Inactive'}
                  </span>
                </div>
              </div>
              <ChevronRightIcon size={20} className={`text-gray-400 transition-transform ${showSourceDetails === source.id ? 'transform rotate-90' : ''}`} data-id="element-372" />
            </div>
            {showSourceDetails === source.id && <div className="px-4 pb-4 pt-2 border-t border-gray-100" data-id="element-373">
                <div className="grid grid-cols-2 gap-2 text-sm" data-id="element-374">
                  <div className="text-gray-500" data-id="element-375">Last Sync:</div>
                  <div className="text-gray-900" data-id="element-376">{source.lastSync}</div>
                  <div className="text-gray-500" data-id="element-377">Stats:</div>
                  <div className="text-gray-900" data-id="element-378">
                    {source.type === 'linkedin' && <>
                        {source.stats.posts} posts
                        <br data-id="element-379" />
                        {source.stats.engagements} engagements
                      </>}
                    {source.type === 'email' && <>
                        {source.stats.sent} sent
                        <br data-id="element-380" />
                        {source.stats.opened} opened
                        <br data-id="element-381" />
                        {source.stats.clicked} clicked
                      </>}
                    {source.type === 'web' && <>
                        {source.stats.visits} visits
                        <br data-id="element-382" />
                        {source.stats.conversions} conversions
                      </>}
                  </div>
                </div>
                <div className="mt-3 flex justify-end" data-id="element-383">
                  <button className="px-3 py-1 text-sm font-medium text-[#f9b30f] hover:text-[#e0a40e]" data-id="element-384">
                    Sync Now
                  </button>
                </div>
              </div>}
          </div>)}
      </div>
      {filteredSources.length === 0 && <div className="py-8 text-center" data-id="element-385">
          <p className="text-gray-500 text-sm" data-id="element-386">
            No {activeTab !== 'all' ? activeTab : ''} sources found. Add a new
            source to get started.
          </p>
        </div>}
    </div>;
};